import { render } from "./SecurityTab.vue?vue&type=template&id=207ac44f"
import script from "./SecurityTab.vue?vue&type=script&lang=js"
export * from "./SecurityTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__